import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../services/index';
import { Tabs ,Modal,message,Input,Select} from 'antd';
import { StickyContainer, Sticky } from 'react-sticky';
import 'antd/dist/antd.css';

import Pagination from "react-js-pagination";

import { v4 as uuidv4 } from 'uuid';
import { GiftedChat } from "react-web-gifted-chat";
import { auth, db, messaging } from '../firebase';

import { getToken, getMessaging, onMessage } from "firebase/messaging";

import { signInWithEmailAndPassword,createUserWithEmailAndPassword,updateProfile } from 'firebase/auth';
import { collection, addDoc, getDocs, query, orderBy, onSnapshot } from 'firebase/firestore';



class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false,
			height: props.height,
			height_2: props.height,
			height_3: props.height,
			height_4: props.height,
			school_id:0,
			user_id:0,
			page: 1,
			perPage: 10,
			student_class:'',
			student_id:0,
			student_name:'',
			user_name:'',
			txtMsg:'',
            messages: [],
			is_open_chat:false,
			total_count:0,
            student_list: []
		}
	}

	componentDidMount() {
		if(localStorage.getItem("schoolData")){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var user_name = storedArray['data'][0]['user_name'];
			 var win_height = window.innerHeight - 120 ;
			 var win_height_2 = window.innerHeight - 255 ;
			 var win_height_3 = window.innerHeight - 123 ;
			 var win_height_4 = window.innerHeight - 169 ;
			 this.setState({height: win_height + 'px'});
			 this.setState({height_2: win_height_2 + 'px'});
			 this.setState({height_3: win_height_3 + 'px'});
			 this.setState({height_4: win_height_4 + 'px'});
			this.setState({ school_id:school_id,user_id:user_id,user_name:user_name}); 
			
			setTimeout(() => {
				this.requestForToken();
				this.getStudentList();
				
				onMessage(messaging, (payload) => {
					if(payload.data.is_show==1){
					    const notificationTitle = payload.data.title;
					    const notificationOptions = {
							body: payload.data.body,
							icon: payload.data.icon,
							message: payload.data.message,
							click_action: payload.data.notification_url, 
					    }; 
					    //var notification = new Notification(notificationTitle, notificationOptions);
					    this.getStudentList(); 
					}   
				});  
			}, 500);  
		}else{
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}
	}
	
	requestForToken = () => {
	  return getToken(messaging, { vapidKey: 'BGC9W3mZIhr8rp3r9JnyTnAtXoD1eNEODkaW8UJtBlhLIWyHDMkfbJ73sepGrMbdB8zzxWmEKsj3SD97R7LXcn0' })
		.then((currentToken) => {
		  if (currentToken) {
			this.updateToken(currentToken);

		  } else {
			// Show permission request UI
			console.log('No registration token available. Request permission to generate one.');
		  }
		}) 
		.catch((err) => {
		  console.log('An error occurred while retrieving token. ', err);
		});
	};
	
	updateToken = (token) => {
		var app = {user_id:this.state.user_id,fcmToken:token}
		getData('chat/update_school_fcm_token_web',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					
				}
			}
		});	
    }  
	
	getStudentList = () => {
		var app = {page : this.state.page,school_id:this.state.school_id,user_id:this.state.user_id,user_id:this.state.user_id}
		getData('chat/student_list',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						student_list: result['data'],
						total_count: result['total_data']
					});
				}else{
					this.setState({
						student_list: [],
						total_count:0
					});
				}
			}
		});	
    } 
	
	async loginFirebase(student_id,student_name){
      var name=student_name;
      var email=student_id+'@mail.com';
      var password='123456';

      signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
          //console.log('yes',userCredential);
		  this.connectUser(student_id);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        if(error.code=='auth/user-not-found'){
          createUserWithEmailAndPassword(auth, email, password)
          .then((userCredential) => {
              const user = userCredential.user;
              updateProfile(user, {
                  displayName: name,
                  photoURL: '',
              })
              .then(() => {
                //console.log('Registered');
				this.connectUser(student_id);
              })
              .catch((error) => {
                  //console.log(error.message);
              })
          })
          .catch((error) => {
              //const errorCode = error.code;
              //const errorMessage = error.message;
          });
        }
      });
    }
	
	connectUser = (child_id) => {
	  var student_id = 'student_'+child_id;
	  const q = query(collection(db, student_id), orderBy('createdAt', 'desc'));
	  const unsubscribe = onSnapshot(q, (snapshot) => this.setMessages(
		  snapshot.docs.map(doc => ({
			  _id: doc.data()._id,
			  createdAt: doc.data().createdAt.toDate(),
			  text: doc.data().text,
			  user: doc.data().user,
		  }))
	  ));
	  return () => {
		unsubscribe();
	  };
   } 
    
   setMessages = (messages) => {
	  this.setState({ messages:messages });
	  this.getStudentList();
   }

   sendMessages = () => {
	    var school_id=this.state.school_id;
	    var user_name=this.state.user_name;
	    var child_id=this.state.student_id;
	    var child_name=this.state.student_name;
		var student_id = 'student_'+child_id;
		var msg = this.state.txtMsg;
		if(msg!=''){ 
			const _id=uuidv4();
			const createdAt=new Date();
			const text=msg;
			const user={_id: school_id+'@mail.com', name: user_name, avatar: null};
			addDoc(collection(db, student_id), { _id, createdAt,  text, user });
			this.sendMsgToServer(text,child_id);	
			this.readChat(child_id);
			this.setState({ txtMsg:'' });
		}
   } 
   
    
   keySendMessages = (event) => { 
	   if(event.key === 'Enter'){
			var school_id=this.state.school_id;
			var user_name=this.state.user_name;
			var child_id=this.state.student_id;
			var child_name=this.state.student_name;
			var student_id = 'student_'+child_id;
			var msg = this.state.txtMsg;
			if(msg!=''){
				const _id=uuidv4();
				const createdAt=new Date();
				const text=msg;
				const user={_id: school_id+'@mail.com', name: user_name, avatar: null};
				addDoc(collection(db, student_id), { _id, createdAt,  text, user });
				this.sendMsgToServer(text,child_id);	
				this.readChat(child_id);
				this.setState({ txtMsg:'' });
			}
	   }
   } 
   
   sendMsgToServer = (message,child_id) => {
		var app = {student_id : child_id,school_id:this.state.school_id,message:message}
		getData('chat/send_messages_to_parents',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){

				}
			}
		});	
    }

   renderMessage  = (messages) => {
		console.log('messages: ',messages);
   }

   renderInputToolbar  = () => {
		return(
			<div class="input_send_div">
			 
				<input name="txtMsg" id="fmsgInput" value={this.state.txtMsg} onChange={this.handleChange} onKeyPress={this.keySendMessages} type="text" placeholder="Type a message..." />
				<button type="button" id="fsendMessages" class="ant-btn ant-btn btn  btn-primary mr-2 send_btn" onClick={this.sendMessages}>Send</button>
		
			</div>
		);
   }

   handleChange = e => {		
		this.setState({ [e.target.name]: e.target.value });		
   }

   changeStudent  = (student_id,student_name,program,division) => {
	    var student_class = program+' - '+division;
		this.setState({ student_id:student_id,student_name:student_name,student_class:student_class });
        this.loginFirebase(student_id,student_name);	
		this.readChat(student_id);
           		
   } 
   
   readChat  = (child_id) => {
		var app = {student_id : child_id,school_id:this.state.school_id}
		getData('chat/read_chat',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.getStudentList();
				}
			}
		});	
   }

   handleKeyword = e => {		
		var keyword=e.target.value;
		
		var app = {page : this.state.page,school_id:this.state.school_id,keyword:keyword}
		getData('chat/student_list',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						student_list: result['data'],
						total_count: result['total_data']
					});
				}else{
					this.setState({
						student_list: [],
						total_count:0
					});
				}
			}
		});
		
        			
   } 

   onChangePage=(pageNumber)=>{
	    this.setState({ page : pageNumber });
	    setTimeout(() => {
		 this.getStudentList();
	    }, 500);
	}   


	render() {
		
		 var email='';
		 var displayName='';
		 var photoURL='';
		 if(auth.currentUser){
			if(auth.currentUser.email){
				email=auth.currentUser.email;
			}
			if(auth.currentUser.displayName){
				displayName=auth.currentUser.displayName;
			}
			if(auth.currentUser.photoURL){
				photoURL=auth.currentUser.photoURL;
			}
		 }

		return (
			<>
			
			
			<div class="row bred">
				<div class="col-md-12">
				<div class="card">
				<div class="card-body">
					<h4 class="page-title"> 
						<i class="mdi mdi-apple-keyboard-command title_icon"></i> Chat
						<div class="breadcrumb-wrapper">
							<ol class="breadcrumb">
								<li class="breadcrumb-item">
									<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
									<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
									</a>
								</li>
								<li class="breadcrumb-item"> Chat</li>
							</ol>
						</div>
					</h4>
				</div>
				</div>
				</div>
			</div>
			
			<div class="row frow"> 
			<div class="col-xl-12 fbg" style={{'height':this.state.height}}>
			<div class="fchat_wrapper">
				<div class="fchat_container">
					<div class="left">
						<div class="top">
							<input type="text" onChange={this.handleKeyword} placeholder="Search" />
						</div>
						<div class="people" style={{'height':this.state.height_2}}>
						{this.state.student_list.length > 0 ? (<> 
						 {this.state.student_list.map((list)=>(
							<div  className={`person ${list.id==this.state.student_id?'person_selected':''}`} data-chat="person1" onClick={this.changeStudent.bind(this,list.id,list.name,list.program,list.division)}>
								<img src={list.image} alt="" />
								<div className={`name ${list.is_read>0?'name_bold':''}`}>{list.name}</div>
								<span class="time">{list.time}</span>
								  {list.is_read>0 && (
									  <span class="is_read">{list.is_read}</span>
								   )}
								<div class="program">{list.program} - {list.division}</div>
								<div className={`last_msg ${list.is_read>0?'last_msg_bold':''}`}>{list.last_msg}</div>
							</div> 
						 ))}
						</>):(<>
							<div class="no-child-found"> No Children Found !!!</div>
						</>)}
						</div>
						 <div class="f_pagination">
							 <Pagination
								activePage={this.state.page}
								itemsCountPerPage={this.state.perPage}
								totalItemsCount={this.state.total_count}
								pageRangeDisplayed={3}
								onChange={this.onChangePage.bind(this)}
							/>
						</div>
					</div>
					<div class="right" style={{'height':this.state.height}}>
					
					  {this.state.student_id>0 ? (
						 <>
						    <div class="top"><span>To: <span class="name">{this.state.student_name} - {this.state.student_class}</span></span></div>
							<div class="fchat_list" style={{'height':this.state.height_4}}>
								<GiftedChat 
									messages={this.state.messages}
									showAvatarForEveryMessage={false}
									showUserAvatar={false}
									renderAvatar={null}
									renderInputToolbar={this.renderInputToolbar}
									//renderMessage={this.renderMessage}
									minInputToolbarHeight={60}
									onSend={messages => this.sendMessages(messages)}
									user={{
										_id: this.state.school_id+'@mail.com',
										name: displayName,
										avatar: null
									}}  
								/> 
							</div>
						 </>
					   ) : (
						 <>
						   <div class="no_chat_list" style={{'height':this.state.height_3}}>
						       <div class="no_chat_list_row">
							      <img class="chat_icon" src="/assets/img/chat.png" />
						          <div class="txt1">Now send and receive messages to parents from here.</div>
							   </div>
						   </div>
						 </>
					   )}
						
					</div>
				</div>
			</div>	
			</div>
			</div>	
 

			</>
		)
	}
}
export default Index;
